/******************************************************************************
 *
 * Copyright (c) 2019-2022 ServiceActivator Inc. All Rights Reserved.
 *
 * Unauthorized copying of the code in this file, completely or partially,
 * via any medium is strictly prohibited.
 *
 * Proprietary and Confidential.
 *
 * Written by 'Shivam Mishra' <shivam.mishra@wakencode.com>, June 2022
 *
 *****************************************************************************/

import React from "react";
import SALogo from "../assets/image/SAHorizontal.png";

/**
 * Header component, it return a logo on web-app
 *
 * @returns JSX for header used inside App component
 */
const Header = () => {
  return (
    <div className="headerLogo">
      <img className="headerImage" src={SALogo} alt="Service Activator Logo"></img>
    </div>
  );
};

export default Header;
